import { ChangeDetectionStrategy, Component, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FilledButtonComponent, OutlinedButtonComponent } from '@custom-components/general/button';
import { DateFieldComponent } from '@custom-components/general/form/date-field/date-field.component';
import { ActivityFilters } from '@core/models/activity.model';
import { TranslateModule } from '@ngx-translate/core';

export type ActivityDateRange = Pick<ActivityFilters, 'initiatedOnFrom' | 'initiatedOnTo'>;

// The From and To days are whole days in the browser's zone: from the start of the one to the end
// of the other.
@Component({
  selector: 'xemex-activity-date-range',
  imports: [
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    DateFieldComponent,
    FilledButtonComponent,
    OutlinedButtonComponent,
    TranslateModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './activity-date-range.component.html',
})
export class ActivityDateRangeComponent {
  readonly rangeChange = output<ActivityDateRange>();

  pendingFrom: Date | undefined;
  pendingTo: Date | undefined;

  protected readonly active = signal(false);

  apply(menuTrigger: MatMenuTrigger): void {
    const from = this.pendingFrom ? new Date(this.pendingFrom) : undefined;
    const to = this.pendingTo ? new Date(this.pendingTo) : undefined;
    from?.setHours(0, 0, 0, 0);
    to?.setHours(23, 59, 59, 999);
    this.active.set(!!(from || to));
    this.rangeChange.emit({
      initiatedOnFrom: from?.toISOString(),
      initiatedOnTo: to?.toISOString(),
    });
    menuTrigger.closeMenu();
  }

  clear(menuTrigger: MatMenuTrigger): void {
    this.pendingFrom = undefined;
    this.pendingTo = undefined;
    this.active.set(false);
    this.rangeChange.emit({});
    menuTrigger.closeMenu();
  }
}
